import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/lab/Slider';

const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    slider: {
        color: '#95c41f'
    },
    typo: {
        fontSize: 14
    }
});

export default function RangeSlider(props) {

    const classes = useStyles();

    const handleChange = (event, newValue) => {
        props.onChange(newValue);
    };

    let marks = Math.max.apply(Math, props.range.filter(r => r ? 1 : 0)) === 0 ? [] :
    props.range.filter(r => r ? true : false).map(r => ({
        value: r,
        label: props.valueFormat(r)
    }));

    // const steps = () => {
    //     let stepsArray = [];
    //     let i = props.range ? props.range[0] : 0;
    //     while (i <= (props.range ? props.range[1] : 0)) {
    //         if (i%1000===0) {
    //             stepsArray.push(i);
    //         }

    //         i++;
    //     }
    //     return stepsArray;
    // }

    return (
        <div className={classes.root}>
            <Typography id="range-slider" gutterBottom className={classes.typo}>
                {props.name}
            </Typography>
            <Slider
                marks={marks}
                className={classes.slider}
                min={props.range ? props.range[0] : 0}
                max={props.range ? props.range[1] : 0}
                value={props.value ? props.value : [0, 0]}
                onChange={handleChange}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
            />
        </div>
    );
}





/*
export default function RangeSlider(props) {
    const classes = useStyles();

    const [state, setState] = React.useState({
        value: props.value ? props.value : [0, 0],
        range: props.range ? props.range : [0, 0]
    });

    React.useEffect(() => {
        setState({
            ...state,
            value: props.value ? props.value : [0, 0],
            range: props.range ? props.range : [0, 0]
        });
    }, [props.range, props.value]);

    const handleChange = (event, newValue) => {
        props.onChange(newValue);
    };

    let marks = Math.max.apply(Math, state.range.filter(r => r ? 1 : 0)) === 0 ? [] :
    state.range.filter(r => r ? true : false).map(r => ({
        value: r,
        label: props.valueFormat(r)
    }));

    return (
        <div className={classes.root}>
            <Typography id="range-slider" gutterBottom className={classes.typo}>
                {props.name}
            </Typography>
            <Slider
                marks={marks}
                className={classes.slider}
                min={state.range[0]}
                max={state.range[1]}
                value={state.value}
                onChange={handleChange}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
            />
        </div>
    );
}*/
